export default __webpack_public_path__ + "static/media/cny-bag.b7a7b4d7.webp";